import styled, { css } from 'styled-components';

export const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Wrapper = styled.div`
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: 0 0 16px 16px;
    padding: 32px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 24px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 32px 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin: 0 0 24px 0;
    }
  `}
`;

/** Skeleton com a mesma altura do título (font-size 1xmedium) */
export const TitleSkeletonWrapper = styled.div`
  ${({ theme }) => css`
    height: ${theme.v3.font.sizes['1xmedium']};
    margin-bottom: 32px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin-bottom: 24px;
    }
  `}
`;

export const TitleWithToggleRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;
    margin-bottom: 32px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin-bottom: 24px;
    }
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const LabelTime = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    width: 1px;
    background-color: ${theme.v3.colors.neutral[80]};
    align-self: stretch;
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const Adapter = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    align-items: flex-start;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      gap: 16px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const TitleAndColumnsContainer = styled.div`
  display: block;
  flex: 1;
  min-width: 0;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    align-items: stretch;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 32px;
    margin-top: 16px;
    padding-left: 8px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      gap: 24px;
      padding-left: 0;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      gap: 24px;
      grid-template-columns: 1fr;
      padding-left: 6px;
    }
  `}
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 0;
    align-items: flex-start;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding-bottom: 24px;
      border-bottom: 1px solid ${theme.v3.colors.neutral[80]};
      
      &:has(${Divider}) {
        display: none;
      }
      
      &:last-of-type {
        border-bottom: none;
      }
    }
  `}
`;

export const ColumnIcon = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes['1xhuge']};
    font-weight: ${theme.v3.font.weights.regular};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    line-height: 1;
    
    svg {
      width: 24px;
      height: 24px;
    }
  `}
`;

export const ColumnTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
`;

export const ColumnTitle = styled.h3`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    gap: 10px;
    justify-content: flex-start;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 4px 0;
  `}
`;

export const ColumnDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 12px 0;
  `}
`;

export const ColumnValue = styled.div`
  ${({ theme, $grey, $green }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    flex-direction: row;
    font-size: ${theme.v3.font.sizes['1xhuge']};
    font-weight: ${theme.v3.font.weights.regular};
    gap: 8px;
    justify-content: flex-start;
    line-height: 130%;
    margin: 0;

    ${$grey && css`
      color: ${theme.v3.colors.neutral[60]};
    `}

    ${$green && css`
      color: ${theme.v3.colors.contextual.active[60]};
    `}
  `}
`;

const getBannerStyleByType = (theme, type) => {
  switch (type) {
    case 'success':
      return css`
        background: ${theme.v3.colors.contextual.active[98]};
        color: ${theme.v3.colors.contextual.active[50]};
      `;
    case 'warning':
      return css`
        background: ${theme.v3.colors.contextual.pending[98]};
        color: ${theme.v3.colors.contextual.pending[50]};
      `;
    case 'success-gradient':
      return css`
        background: linear-gradient(90deg, ${theme.v3.colors.contextual.active[98]} 0%, ${theme.v3.colors.brand.snappyBlue[80]} 100%);
        color: ${theme.v3.colors.brand.snappyBlue[30]};
      `;
    case 'critical':
      return css`
        background: ${theme.v3.colors.contextual.problem[98]};
        color: ${theme.v3.colors.contextual.problem[50]};
      `;
    default:
      return '';
  }
};

export const StatusBanner = styled.div`
  ${({ theme, type }) => css`
    align-items: center;
    border-radius: 16px 16px 0 0;
    display: flex;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    gap: 4px;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-top: -16px;
    padding: 16px 24px;
    position: relative;
    ${getBannerStyleByType(theme, type)}
  `};
`;

export const StatusIcon = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 16px;
`;

export const FullProtectionBannerContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 4px;
    align-items: center;
    min-width: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
  `}
`;

export const FullProtectionBannerText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AutomaticRemovalRow = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;
  gap: 4px;
  max-width: 100%;
`;

export const ToggleLabel = styled.label`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  margin: 0;
  max-width: 100%;
  
  label {
    flex-shrink: 0;
  }
`;

export const ToggleColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WithoutLastScanRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  width: 100%;
`;

export const LastScanTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size:14px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const LastScanDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const LastScanInfo = styled.div`
  display: flex;
  margin: 28px 0px;
`;

export const LastScanData = styled.span`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[40]};
  `}
`;

export const EnableYourProtection = styled.span`
  ${({ theme }) => css`
    font-size: 12px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[40]};
  `}
`;
